import { AutogenModelObjection, AutogenRowObjection } from "./autogen/AutogenModelObjection";

export class ModelObjection extends AutogenModelObjection<RowObjection> {
	constructor() {
		super(RowObjection);
	}
}

export class RowObjection extends AutogenRowObjection {
}